/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).fadeToggle();
      } );

      $( 'button.easy-toggle-fade-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( this ).trigger( 'focus' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#nav-overlay' ) {
            $( target ).fadeToggle();
          }
        } );
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( this ).trigger( 'focus' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#nav-overlay' ) {
            $( target ).slideToggle();
          }
        } );
      } );

      // Add cmd + ctr + g shortcut for showing grid over site if site options environment is set to development
      document.addEventListener( 'keydown', function( event ) {
        if ( event.ctrlKey && event.metaKey && event.key === 'g' ) {
          toggleGridOverlay();
        }
      } );

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Primary button */
      const positionAwareButtonSelector = '.btn-primary, .mec-events-gcal, .mec-events-button, .mec-booking-button, .mec-modal-booking-button, .btn-ghost, .mec-load-more-button, .single_add_to_cart_button, .wc-forward, .wc-block-components-totals-coupon__button, .wc-block-components-button, .woocommerce-button, .woocommerce-MyAccount-content a.button, .woocommerce-Button, .wp-element-button';
      const updatePositionAwareButton = function( e ) {
        if ( !window.hasMotion ) return;

        const buttonRect = this.getBoundingClientRect();
        const relX = e.clientX - buttonRect.left;
        const relY = e.clientY - buttonRect.top;

        this.style.setProperty( '--positionAwareTop', `${relY}px` );
        this.style.setProperty( '--positionAwareLeft', `${relX}px` );
      };

      $( document ).on(
          'mouseenter mousemove mouseleave',
          positionAwareButtonSelector,
          updatePositionAwareButton,
      );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
            $( 'button[data-toggle-trigger-off].trigger-off__mobile-only' ).removeAttr( 'data-toggle-trigger-off' );
            $( 'button[data-toggle-outside].outside__mobile-only' ).removeAttr( 'data-toggle-outside' );
          }
        } else {
          $( 'button[data-toggle-outside].outside__desktop-only' ).removeAttr( 'data-toggle-outside' );
          // is mobile
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }
      if ( $( '.mec-breadcrumbs' ).length > 0 ) {
        const updateBreadCrumbHeight = function() {
          const $breadCrumbHeight = $( '.mec-breadcrumbs' ).outerHeight();
          $( ':root' ).css( '--liftedMecBreadCrumbHeight', $breadCrumbHeight + 'px' );
        };
        updateBreadCrumbHeight();
        const throttledUpdateBreadCrumbHeight = new app.components.common.Throttle( updateBreadCrumbHeight, 250 );
        $( window ).on( 'resize', function() {
          throttledUpdateBreadCrumbHeight.run();
        } );
      }
      // set mec theme classes
      if ( $( '.mec-skin-grid-events-container' ).length ) {
        $( '.mec-skin-grid-events-container' ).addClass( 'theme-two' );
      }
      if ( $( '.mec-container' ).length ) {
        $( '.mec-container' ).addClass( 'theme-two' );
      }
      if ( $( '.single-mec-events' ).length ) {
        $( '.single-mec-events' ).addClass( 'theme-two bg-theme-background-fill' );
      }
      if ( $( '.mec-event-article .mec-event-content .mec-event-date' ).length ) {
        $( '.mec-event-date' ).addClass( 'theme-three' );
      }

      /* Join MEC's duplicate multi-day entries into week-spanning event bars. */
      const mecCalendar = document.querySelector( '.mec-full-calendar-wrap .mec-calendar' );
      if ( mecCalendar ) {
        const renderMecMultiDayBars = function() {
          mecCalendarObserver.disconnect();

          const weekdayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          mecCalendar.querySelectorAll( '.mec-calendar-day-head' ).forEach( function( heading, index ) {
            heading.textContent = weekdayLabels[index] || heading.textContent;
          } );

          const calendarTable = mecCalendar.querySelector( '.mec-calendar-table' );
          if ( calendarTable && calendarTable.dataset.mecScrollInitialized !== 'true' ) {
            calendarTable.scrollLeft = 0;
            calendarTable.dataset.mecScrollInitialized = 'true';
          }

          mecCalendar.querySelectorAll( '.mec-monthly-tooltip' ).forEach( function( eventLink ) {
            if ( eventLink.classList.contains( 'tooltipstered' ) ) {
              try {
                $( eventLink ).tooltipster( 'destroy' );
              } catch ( error ) {
                eventLink.classList.remove( 'tooltipstered' );
              }
            }
            eventLink.classList.remove( 'mec-monthly-tooltip' );
            eventLink.removeAttribute( 'data-tooltip-content' );
          } );

          /* MEC moves event links out of day cells on mobile. Restore lightweight
           * copies so event titles and multi-day bars use the same calendar UI. */
          if ( window.innerWidth < 768 ) {
            mecCalendar.querySelectorAll( '.mec-calendar-events-sec[data-mec-cell]' ).forEach( function( eventSection ) {
              const cell = mecCalendar.querySelector( '.mec-calendar-day[data-mec-cell="' + eventSection.dataset.mecCell + '"]' );
              if ( !cell ) return;

              eventSection.querySelectorAll( '.mec-event-title a[data-event-id]' ).forEach( function( sourceLink ) {
                if ( cell.querySelector( ':scope > div > a[data-event-id="' + sourceLink.dataset.eventId + '"]' ) ) return;

                const eventWrapper = document.createElement( 'div' );
                eventWrapper.className = 'mec-restored-mobile-event';

                const eventLink = document.createElement( 'a' );
                eventLink.dataset.eventId = sourceLink.dataset.eventId;
                eventLink.href = sourceLink.href;
                eventLink.target = sourceLink.target || '_self';
                if ( sourceLink.rel ) eventLink.rel = sourceLink.rel;

                const eventTitle = document.createElement( 'h4' );
                eventTitle.className = 'mec-event-title';
                eventTitle.textContent = sourceLink.textContent.trim();

                eventLink.appendChild( eventTitle );
                eventWrapper.appendChild( eventLink );
                cell.appendChild( eventWrapper );
              } );
            } );
          }

          mecCalendar.querySelectorAll( '.mec-calendar-row > dt' ).forEach( function( cell ) {
            const dateTextNode = Array.from( cell.childNodes ).find( function( node ) {
              return (
                node.nodeType === Node.TEXT_NODE &&
                /^\d{1,2}$/.test( node.textContent.trim() )
              );
            } );
            if ( dateTextNode ) {
              const dayNumber = document.createElement( 'div' );
              dayNumber.className = 'mec-calendar-day-number';
              dayNumber.textContent = dateTextNode.textContent.trim();
              cell.replaceChild( dayNumber, dateTextNode );
            } else {
              const firstElement = cell.firstElementChild;
              if (
                firstElement &&
                /^\d{1,2}$/.test( firstElement.textContent.trim() )
              ) {
                firstElement.classList.add( 'mec-calendar-day-number' );
              }
            }
          } );

          mecCalendar.querySelectorAll( '.mec-multiday-bar, .mec-multiday-continuation, .mec-after-multiday' ).forEach( function( element ) {
            element.classList.remove( 'mec-multiday-bar', 'mec-multiday-continuation', 'mec-after-multiday' );
            element.style.removeProperty( '--mec-multiday-width' );
            element.style.removeProperty( '--mec-multiday-lane' );
            element.style.removeProperty( '--mec-multiday-stack-height' );
          } );

          mecCalendar.querySelectorAll( '.mec-calendar-row' ).forEach( function( row ) {
            const cells = Array.from( row.querySelectorAll( ':scope > .mec-calendar-day' ) );
            const events = new Map();
            const multidayLaneEnds = [];
            const multidayRanges = [];

            cells.forEach( function( cell, cellIndex ) {
              cell.querySelectorAll( ':scope > div > a[data-event-id]' ).forEach( function( link ) {
                const eventId = link.dataset.eventId;
                if ( !events.has( eventId ) ) events.set( eventId, [] );
                events.get( eventId ).push( {
                  cell: cell,
                  cellIndex: cellIndex,
                  link: link,
                  wrapper: link.parentElement,
                } );
              } );
            } );

            events.forEach( function( occurrences ) {
              occurrences.sort( function( a, b ) {
                return a.cellIndex - b.cellIndex;
              } );

              let sequence = [];
              const finishSequence = function() {
                if ( sequence.length < 2 ) {
                  sequence = [];
                  return;
                }

                const first = sequence[0];
                const last = sequence[sequence.length - 1];
                const firstRect = first.cell.getBoundingClientRect();
                const lastRect = last.cell.getBoundingClientRect();
                const width = Math.max( 0, lastRect.right - firstRect.left - 8 );
                let lane = multidayLaneEnds.findIndex( function( laneEnd ) {
                  return laneEnd < first.cellIndex;
                } );
                if ( lane === -1 ) lane = multidayLaneEnds.length;
                multidayLaneEnds[lane] = last.cellIndex;
                multidayRanges.push( {
                  start: first.cellIndex,
                  end: last.cellIndex,
                  lane: lane,
                } );

                first.wrapper.classList.add( 'mec-multiday-bar' );
                first.wrapper.style.setProperty( '--mec-multiday-width', width + 'px' );
                first.wrapper.style.setProperty( '--mec-multiday-lane', lane );
                sequence.slice( 1 ).forEach( function( occurrence ) {
                  occurrence.wrapper.classList.add( 'mec-multiday-continuation' );
                } );
                sequence = [];
              };

              occurrences.forEach( function( occurrence ) {
                const previous = sequence[sequence.length - 1];
                if ( previous && occurrence.cellIndex !== previous.cellIndex + 1 ) finishSequence();
                sequence.push( occurrence );
              } );
              finishSequence();
            } );

            cells.forEach( function( cell, cellIndex ) {
              const coveringRanges = multidayRanges.filter( function( range ) {
                return range.start < cellIndex && range.end >= cellIndex;
              } );
              if ( !coveringRanges.length ) return;

              const stackHeight = ( Math.max.apply( null, coveringRanges.map( function( range ) {
                return range.lane;
              } ) ) + 1 ) * 35;

              cell.querySelectorAll( ':scope > div' ).forEach( function( eventWrapper ) {
                if (
                  eventWrapper.classList.contains( 'tooltip_templates' ) ||
                  eventWrapper.classList.contains( 'mec-multiday-bar' ) ||
                  eventWrapper.classList.contains( 'mec-multiday-continuation' ) ||
                  !eventWrapper.querySelector( ':scope > a[data-event-id]' )
                ) return;

                eventWrapper.classList.add( 'mec-after-multiday' );
                eventWrapper.style.setProperty( '--mec-multiday-stack-height', stackHeight + 'px' );
              } );
            } );
          } );

          mecCalendarObserver.observe( mecCalendar, {
            childList: true,
            subtree: true,
          } );
        };

        const mecCalendarObserver = new MutationObserver( function( mutations ) {
          if ( mutations.some( function( mutation ) {
            return mutation.addedNodes.length || mutation.removedNodes.length;
          } ) ) {
            window.requestAnimationFrame( renderMecMultiDayBars );
          }
        } );

        renderMecMultiDayBars();
        const resizeMultiDayBars = new app.components.common.Throttle( renderMecMultiDayBars, 150 );
        $( window ).on( 'resize', function() {
          resizeMultiDayBars.run();
        } );

        const openMecMobileEvent = function( event ) {
          if ( window.innerWidth > 768 ) return;

          const eventLink = event.target.closest( 'a[data-event-id]' );
          if ( !eventLink || !mecCalendar.contains( eventLink ) ) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign( eventLink.href );
        };
        document.addEventListener( 'touchend', openMecMobileEvent, true );
        document.addEventListener( 'click', openMecMobileEvent, true );
      }

      document.addEventListener( 'click', function( e ) {
        const toggle = e.target.closest( '.password-show' );
        if ( !toggle ) return;

        e.preventDefault();
        const input = toggle.previousElementSibling;
        if ( !input || input.tagName !== 'INPUT' ) return;

        const isShowing = toggle.classList.toggle( 'is-show' );
        input.type = isShowing ? 'text' : 'password';
      } );

      const isProtectedImage = function( target ) {
        if ( !target || typeof target.closest !== 'function' ) return false;
        if ( target.closest( '#wpadminbar, .mfp-close, [data-allow-image-menu]' ) ) return false;
        return !!target.closest( 'img, picture, svg' );
      };

      ['contextmenu', 'dragstart'].forEach( function( eventName ) {
        document.addEventListener( eventName, function( e ) {
          if ( isProtectedImage( e.target ) ) {
            e.preventDefault();
          }
        } );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
